import React from "react";
import { HiBars3, HiUser } from "react-icons/hi2";
import "./style.css";

const LoginHeader = (props) => {
  return (
    <div style={{ backgroundColor: "#000E54", padding: "14px 16px" }}>
      <div className="textall">
        <div className="speech">{"Speech App"} </div>

        <div className="dropdown1 uicon">
            Login
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;
